import { required } from 'vuelidate/lib/validators';

export default requiredIf => function (value, parentVm) {
  const compareTo = typeof requiredIf === 'function'
      ? requiredIf.call(this, parentVm)
      : parentVm[requiredIf];
  return !compareTo || required(value);
};



// WEBPACK FOOTER //
// ./src/utils/validators/RequiredIf.js